import { defineMessages } from '@sm/intl';

export default defineMessages({
  PRODUCTS: {
    id: 'Mobile.products',
    defaultMessage: 'Products',
    description:
      '[Type: Label][Vis.: high] - This is the Products title of mobile menu.',
  },
  HELP: {
    id: 'Mobile.help',
    defaultMessage: 'Help',
    description:
      '[Type: Label][Vis.: high] - This is the Help title of mobile menu',
  },
  SIGN_OUT: {
    id: 'Mobile.sign_out',
    defaultMessage: 'Sign Out',
    description:
      '[Type: Label][Vis.: high] - This is the sign out link in the mobile menu.',
  },
});
